import React, { Fragment, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_CUENTO } from '../../graphql/actions/cuento';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';

import sectionFullDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDetailsStyle';

const useStyles = makeStyles(sectionFullDataStyle);

const CuentoDetails = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();

  const {
    loading: loadingCuento,
    error: errorCuento,
    data: dataCuento,
  } = useQuery(GET_CUENTO, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  let seccionCuento = null;
  let showNotification = null;

  if (loadingCuento) {
    seccionCuento = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorCuento) {
    seccionCuento = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando el cuento.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    showNotification = errorCuento.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorCuento ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataCuento && dataCuento.getCuento) {
    const { getCuento } = dataCuento;
    //console.log(getCuento);
    seccionCuento = (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8} key={getCuento._id}>
          <h3 className={classes.title}>{getCuento.titulo}</h3>
          <p>Por {getCuento.autor}</p>
          <div dangerouslySetInnerHTML={{ __html: getCuento.contenido }}></div>
        </GridItem>
      </GridContainer>
    );
  }

  return (
    <Fragment>
      <div className={classes.main} id='main-panel'>
        <div className={classes.container}>
          <div className={classes.section}>{seccionCuento}</div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default CuentoDetails;
